import { render, staticRenderFns } from "./MetlifeLogo.vue?vue&type=template&id=3042ca4e"
import script from "./MetlifeLogo.vue?vue&type=script&lang=js"
export * from "./MetlifeLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports